var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"panel-nav__back",on:{"click":_vm.back}})
}
var staticRenderFns = []

export { render, staticRenderFns }